const API_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

export const TRIAL_PERIOD_DAYS = 7;

export const PLATFORM_FEATURES = [
  '20,000 active UCAT questions',
  '25 full mock exams',
  'Detailed analytics',
  'Study guides access',
];

/** Shown immediately on the landing page; replaced when the API responds. */
export const FALLBACK_PLANS = [
  { id: 'weekly', name: 'Weekly', price: 14.99, price_aud: 14.99, duration_days: 7, currency: 'AUD', highlight: false, features: PLATFORM_FEATURES },
  { id: 'monthly', name: 'Monthly', price: 34.99, price_aud: 34.99, duration_days: 30, currency: 'AUD', highlight: false, features: PLATFORM_FEATURES },
  { id: '3month', name: '3 Months', price: 54.99, price_aud: 54.99, duration_days: 90, currency: 'AUD', highlight: true, features: PLATFORM_FEATURES },
  { id: '6month', name: '6 Months', price: 64.99, price_aud: 64.99, duration_days: 180, currency: 'AUD', highlight: false, features: PLATFORM_FEATURES },
  { id: 'annual', name: 'Annual', price: 74.99, price_aud: 74.99, duration_days: 365, currency: 'AUD', highlight: false, features: PLATFORM_FEATURES },
];

export const CURRENCY_SYMBOLS = {
  AUD: 'A$',
  USD: '$',
  GBP: '£',
  EUR: '€',
  NZD: 'NZ$',
  CAD: 'C$',
  INR: '₹',
};

export const CURRENCY_OPTIONS = Object.keys(CURRENCY_SYMBOLS);

export function getCurrencySymbol(currency) {
  return CURRENCY_SYMBOLS[currency] || '$';
}

export function getWeeklyPrice(plan) {
  const weeks = plan.duration_days / 7;
  const price = plan.price / weeks;
  return plan.id === 'weekly' ? Math.ceil(price) : price.toFixed(2);
}

export function calculateSavings(plan, plans) {
  if (!plans.length || plan.id === 'weekly') return null;
  const weeklyPlan = plans.find((p) => p.id === 'weekly');
  if (!weeklyPlan) return null;
  const weeks = plan.duration_days / 7;
  const weeklyTotal = weeklyPlan.price * weeks;
  const savings = Math.round(((weeklyTotal - plan.price) / weeklyTotal) * 100);
  return savings > 0 ? savings : null;
}

export function formatDurationLabel(days) {
  if (days === 7) return 'Renews weekly';
  if (days === 30) return 'Renews monthly';
  if (days === 90) return 'Renews every 3 months';
  if (days === 180) return 'Renews every 6 months';
  if (days === 365) return 'Renews yearly';
  return `Renews every ${days} days`;
}

function getPlansUrl(currency = 'AUD') {
  const query = `currency=${encodeURIComponent(currency)}`;
  if (API_URL) {
    return `${API_URL}/api/subscriptions/plans?${query}`;
  }
  return `/api/subscriptions/plans?${query}`;
}

export async function fetchSubscriptionPlans({ api, currency = 'AUD' } = {}) {
  if (api) {
    const response = await api.get(`/subscriptions/plans?currency=${currency}`);
    return response.data;
  }
  const response = await fetch(getPlansUrl(currency));
  if (!response.ok) throw new Error('Failed to load plans');
  return response.json();
}
